import { ComponentType } from 'react';
import { css } from 'styled-components';

type PolymorphicAs = { as?: string | ComponentType };

// This should typically be reset by the apps, but currently, ardoq-front does not handle this reset, so we've added a reset here to avoid any issues.
export const listResetCss = ({ as }: PolymorphicAs) =>
  (as === 'ul' || as === 'ol') &&
  css`
    padding: 0;
    margin: 0;
    & :where(li) {
      list-style-type: none;
    }
  `;
